import "./RiepilogoPage.css";
import { t, getFullDateString, getFullHourAndMinute } from "../../services/formatters";
import { useRiepilogoPage } from "./useRiepilogoPage";
import userIcon from "../../assets/imgs/recap-user-icon.svg";
import bannerPhoneIcon from "../../assets/imgs/scarica-app-phone.svg";
import bannerQrIcon from "../../assets/imgs/scarica-app-qr.svg";
import calendarIcon from "../../assets/imgs/recap-calendar-icon.svg";
import pinIcon from "../../assets/imgs/recap-pin-icon.svg";
import actionMapIcon from "../../assets/imgs/action-map-icon.svg";
import actionDirectionsIcon from "../../assets/imgs/action-directions-icon.svg";
import actionPrintIcon from "../../assets/imgs/action-print-icon.svg";
import actionPdfIcon from "../../assets/imgs/action-pdf-icon.svg";
import actionCalendarIcon from "../../assets/imgs/action-calendar-icon.svg";
import { Button } from "../../components/Button";
import { AuditQuestion } from "../../components/AuditQuestion";
import spinnerIcon from "../../assets/imgs/spinner.gif";
import audits from "../../config/audit.json";
import { useEffect } from "react";
import md5 from "blueimp-md5";
import sha256 from "crypto-js/sha256";

export const RiepilogoPage = () => {
    const {
        read,
        onShowMapClick,
        onGetDirectionsClick,
        onPrintClick,
        onDownloadPdfClick,
        onSaveToICalClick,
        auditSent,
        sendAuditAnswers,
        onAuditChange,
        isSendAuditError,
        isSendAuditBusy,
        askForEditAppointment,
        codiceFiscaleError,
        busy,
        onDownloadBannerClick,
    } = useRiepilogoPage();

    useEffect(() => {
        let privacy_mtk_consent_string = "";
        let privacy_mtk_consent_array = [];
        if (read("privacyExtcommoffer") == "1") privacy_mtk_consent_array.push("Dati personali");
        if (read("privacyOtherservice") == "1") privacy_mtk_consent_array.push("Informativa");
        if (read("privacyProfilazione") == "1") privacy_mtk_consent_array.push("Societa terze");
        privacy_mtk_consent_string = privacy_mtk_consent_array.join(" - ");

        window.dataLayer.push({
            event: "customPageview",
            virtualPageURL: read("ricontattoLuogo") == true && read("ricontattoCf") == true ? "/fa3/fissa-appuntamento/thank-you-page-clink" : "/fa3/fissa-appuntamento/thank-you-page",
            crmIdentification: read("utenteRiconosciuto") && read("utenteRiconosciuto") == true ? "utente riconosciuto" : "nuovo utente",
            privacy_mtk_consent: privacy_mtk_consent_string,
            funnelVersion: "nuovo",
            capFiliale: read("cap"),
            userID: read("contactID"),
            oppID: read("oppID"),
            // c_mdx: sha256(read("codiceFiscale") || "0").toString(),
            c_shx: sha256(read("codiceFiscale") || "0").toString(),
            // m_mdx: sha256(read("email") || "0").toString(),
            m_shx: sha256(read("email") || "0").toString(),
            // p_mdx: sha256(read("cellulare") || "0").toString(),
            p_shx: sha256(read("cellulare") || "0").toString(),
            presa_info: read("solo_info"),
        });
    }, []);

    return (
        <div id="riepilogo-page">
            {/* titolo */}
            {read("ricontatto") == false && (!read("ricontatto_external") || read("ricontatto_external") != "1") ? (
                <div className={`section page-title-component center-on-tablet`}>
                    <h1>{t("ti_aspettiamo")}</h1>
                    <div>{t("ecco_il_riepilogo")}</div>
                </div>
            ) : (
                <div className="section padding-x2 thank-you-text-extended-component text-center">
                    <p className="text-lg bold">{t("grazie_esteso")}</p>
                    <br />
                    <p>{t("sarai_contattato")}</p>
                </div>
            )}

            {/* recap */}
            {read("ricontatto") == false && (!read("ricontatto_external") || read("ricontatto_external") != "1") && (
                <>
                    <div className="appointment-recap-component white-box text-center">
                        <div className="section">
                            <img src={userIcon} />
                            <h3 className="semibold">
                                {read("nome")} {read("cognome")}
                            </h3>
                            <p>{read("email")}</p>
                            <p>{read("cellulare")}</p>
                        </div>
                        <div className="section">
                            <img src={calendarIcon} />
                            {read("dataScelta") && read("orarioScelto") && (
                                <h3 className="semibold">
                                    {getFullDateString(read("dataScelta").data)} - Ore {getFullHourAndMinute(read("orarioScelto").hour, read("orarioScelto").minute)}
                                </h3>
                            )}
                        </div>
                        <div className="section">
                            <img src={pinIcon} />
                            <h3 className="semibold">{read("filialeScelta").nomeFiliale}</h3>
                            <p>{read("filialeScelta").indirizzo}</p>
                        </div>
                    </div>

                    {/* banner download the app */}
                    <div id="banner-download-app" className="section centered-content">
                        <div className="red-box" onClick={onDownloadBannerClick}>
                            <div className="flex-row top-vertical">
                                <div className="flex-cell" style={{ flex: "0" }}>
                                    <img id="banner-download-app_phone-icon" src={bannerPhoneIcon} alt="" />
                                </div>

                                <div id="banner-download-app_copy" className="flex-cell">
                                    <span className="hide-mobile show-tablet show-desktop">Scarica l’app di Compass e richiedi un prestito ovunque tu sia.</span>
                                    <span className="show-mobile hide-tablet hide-desktop">Scarica l’app di Compass e richiedi un prestito ovunque tu sia.</span>
                                    <br />
                                    <Button classList="always-style show-mobile hide-tablet hide-desktop" compact onClick={() => {}} text="SCARICA L'APP" />
                                </div>
                            </div>
                            <div className="flex-row">
                                <div className="flex-cell">
                                    <img className="hide-mobile show-tablet show-desktop" src={bannerQrIcon} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* icone azioni */}
                    <div className="section action-icons flex-row centered-content">
                        <div className="flex-cell">
                            <Button title={t("mostra_su_mappa")} onClick={onShowMapClick} aria={t("mostra_su_mappa")} iconSrc={actionMapIcon} />
                        </div>
                        <div className="flex-cell">
                            <Button title={t("ottieni_indicazioni")} onClick={onGetDirectionsClick} aria={t("ottieni_indicazioni")} iconSrc={actionDirectionsIcon} />
                        </div>
                        <div className="flex-cell">
                            <Button title={t("stampa")} aria={t("stampa")} onClick={onPrintClick} iconSrc={actionPrintIcon} />
                        </div>
                        <div className="flex-cell">
                            <Button title={t("scarica_pdf")} aria={t("scarica_pdf")} onClick={onDownloadPdfClick} iconSrc={actionPdfIcon} />
                        </div>
                        <div className="flex-cell">
                            <Button title={t("salva_in_calendario")} aria={t("salva_in_calendario")} onClick={onSaveToICalClick} iconSrc={actionCalendarIcon} />
                        </div>
                    </div>
                </>
            )}

            {/* audit */}
            {!auditSent && (
                <>
                    <AuditQuestion
                        choices={audits.lavoro_1}
                        name="impiego"
                        title={t("audit_impiego")}
                        onChange={(value) => {
                            onAuditChange("impiego", value);
                        }}
                    />
                    <AuditQuestion
                        choices={audits.consolidamento}
                        name="consolidamento"
                        title={t("audit_finanziamenti")}
                        onChange={(value) => {
                            onAuditChange("consolidamento", value);
                        }}
                    />

                    <div className="text-center">
                        <Button classList="always-style" compact onClick={sendAuditAnswers} text={t("invia")} loading={isSendAuditBusy} />
                        {isSendAuditError && (
                            <div className="text-center text-error anim-pulse text-small">
                                <br />È necessario selezionare una risposta a tutte le domande
                            </div>
                        )}
                    </div>
                </>
            )}

            {auditSent && (
                <div className="text-center thank-you-text-component">
                    <p className="text-xl">{t("grazie")}</p>
                    <p className="text-md semibold" dangerouslySetInnerHTML={{ __html: t("audit_spiegazione") }}></p>
                </div>
            )}

            {/* modifica appuntamento appena fissato */}
            {(read("oppID") || read("oppID_external")) && (
                <div className="text-center">
                    <br />
                    <div
                        className={`section edit-appointment-link-component text-uppercase color-text-primary clickable ${busy ? "busy" : ""}`}
                        onClick={() => {
                            if (busy) return;
                            askForEditAppointment();
                        }}>
                        {t("modifica_appuntamento")}
                        <img className="state-icon" src={spinnerIcon} />
                        {codiceFiscaleError && (
                            <>
                                <br />
                                <p className="text-small error text-center text-no-transform">
                                    Non siamo riusciti a trovare il tuo appuntamento. <br /> Riprova, per favore.
                                </p>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};
